import styled from "styled-components";

import { colors, radii } from "shared/ui/tokens";

export const Input = styled.input`
    width: 100%;
    height: 44px;
    padding: 0 12px;
    border: 1px solid ${colors.fieldBorder};
    border-radius: ${radii.base};
    background: ${colors.surface};
    color: ${colors.textPrimary};
    outline: none;

    /* Нативный input[type=date] по умолчанию рисуется системным шрифтом —
       принудительно наследуем Manrope и выравниваем цифры по ширине. */
    font-family: inherit;
    font-size: 15px;
    font-variant-numeric: tabular-nums;
    line-height: normal;

    &:focus {
        border-color: ${colors.primary};
    }

    &:disabled {
        background: ${colors.segmentBg};
        color: ${colors.textSecondary};
    }

    /* Убираем внутренние отступы WebKit, иначе поле «прыгает» относительно соседних инпутов. */
    &::-webkit-date-and-time-value {
        margin: 0;
        text-align: left;
    }

    &::-webkit-datetime-edit {
        padding: 0;
    }

    &::-webkit-datetime-edit-fields-wrapper {
        padding: 0;
    }

    &::-webkit-calendar-picker-indicator {
        margin-left: 4px;
        opacity: 0.45;
        cursor: pointer;
        transition: opacity 0.15s ease;
    }

    &:hover::-webkit-calendar-picker-indicator {
        opacity: 0.75;
    }

    &:disabled::-webkit-calendar-picker-indicator {
        opacity: 0.25;
        cursor: default;
    }
`;
